import PropTypes from 'prop-types';
import { Modal, Input, Button } from 'antd';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { CloseIcon, NewCancelIcon, NewUpdateIcon } from '../Common/Icons';

const AddRadarSensorModal = ({
  isAddRadarSensorModalOpen,
  closeAddRadarSensorModal,
  homeId,
  setHomeId,
  submitAddRadarSensor,
  isSubmitting,
}) => {
  const trans = useSelector(translator);
  const isSubmitDisabled = !homeId || isSubmitting;

  return (
    <Modal
      open={isAddRadarSensorModalOpen}
      onCancel={closeAddRadarSensorModal}
      footer={null}
      closable={false}
      centered
      className="device-page-add-radar-sensor-modal"
    >
      <div className="device-page-modal-container">
        <span className="assign-smart-camera-title">{trans('ADDRADARSENSOR')}</span>
        <div className="modal-close-button" onClick={closeAddRadarSensorModal}>
          <CloseIcon className="modal-close-icon" />
        </div>
      </div>
      <div className="add-radar-sensor-form">
        <div className="add-radar-sensor-field">
          <label className="add-radar-sensor-label">{trans('PONTOSENSEHOMEID')}</label>
          <Input
            className="add-radar-sensor-input"
            value={homeId}
            onChange={(e) => setHomeId(e.target.value)}
            placeholder={trans('PONTOSENSEHOMEID')}
          />
        </div>
      </div>
      <div className="assign-smart-camera-modal-footer">
        <Button
          className="custom-no-button"
          onClick={closeAddRadarSensorModal}
          disabled={isSubmitting}
        >
          <NewCancelIcon />
          <span className="custom-no-label">{trans('CANCEL')}</span>
        </Button>
        <Button
          className={`custom-yes-button ${isSubmitDisabled ? 'disabled-button' : ''}`}
          onClick={submitAddRadarSensor}
          disabled={isSubmitDisabled}
          loading={isSubmitting}
        >
          {!isSubmitting && (
            <NewUpdateIcon
              className={`assigned-selected-icon ${isSubmitDisabled ? 'disabled-icon' : ''}`}
            />
          )}
          <span className={`custom-yes-label ${isSubmitDisabled ? 'disabled-label' : ''}`}>
            {trans('SUBMIT_U')}
          </span>
        </Button>
      </div>
    </Modal>
  );
};

AddRadarSensorModal.propTypes = {
  isAddRadarSensorModalOpen: PropTypes.bool.isRequired,
  closeAddRadarSensorModal: PropTypes.func.isRequired,
  homeId: PropTypes.string,
  setHomeId: PropTypes.func.isRequired,
  submitAddRadarSensor: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

export default AddRadarSensorModal;
